import React, {useRef, useState} from 'react';

import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import {
    FORM,
    MAX_NAME,
    REQUIRED,
} from "../../../components/i18n/i18n";
import {
    ButtonCancel,
    ButtonSubmit, GenericTableButton
} from "../../../components/buttons/buttonsActions";
import * as Yup from "yup";
import {MAX_NAME_SIZE} from "../../../components/menu-flower/constants";
import {ErrorMessage, useForm} from "react-hook-form";
import LegalLangs from "./_langs";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {save, update} from "../../../redux/actions/eventx/legalActions";
import {connect} from "react-redux";
import {legalService} from "../../../jwt/_services/clasificator/legalService";
import {getCurrentDateForCodeField} from "../../../util/DateTools";


function LegalForm(props) {

    const { editMode, domainObject } = props.formProps;
    const translatableLangs = domainObject?.translatedLangs || []
    const { udn } = props.mainProps;
    const fbDataBaseId = props.mainProps?.app?.fbDataBase?.id
    const [langs, setLangs] = useState(domainObject?.langs || []);

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required(REQUIRED).max(MAX_NAME_SIZE, MAX_NAME),
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            code: domainObject?.code,
            uid: domainObject?.uid,
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            fbDataBase :  { id : fbDataBaseId },
            item : {
                id: domainObject?.id,
                uid: domainObject?.uid,
                code: data.code,
                oldCode: domainObject?.oldCode || `LEGAL_` + getCurrentDateForCodeField().toLowerCase(),
                langs: langs,
                udn: { id: udn.id },
            }
        };
        try{
            if (editMode) {
                let id = domainObject.id;

                props.update(id, dataRequest)
            } else {
                props.save(dataRequest)
            }
            closeForm()
        } catch (error) {
            console.log(error)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.setItem(null);
        props.setForm();
        props.onClose()
    }


    return (
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label>Codigo</Label>
                                <Input type="text" name="code"
                                       placeholder=" Código"
                                       innerRef={register}
                                       className={(errors.code ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="code" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="mdi mdi-book mr-2"/>
                        Información internacional
                    </CardTitle>
                    <CardBody>
                        <LegalLangs
                            langs={langs}
                            setLangs={setLangs}
                            translatableLangs={translatableLangs}
                            service={legalService}
                        />
                    </CardBody>
                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonSubmit/>
                            <ButtonCancel onClick={closeForm}/>
                        </div>
                    </CardBody>
                </Form>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ domainObject }
                />
            }
        </Card>
    )
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setItem,
    setForm,
    save,
    update,
})

export default connect(mapStateToProps, mapActionsToProps)(LegalForm)